require('./artist');


// WEBPACK FOOTER //
// ./resources/assets/js/modules/form/index.js